





































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WizardMenu extends Vue {
  /* ------------- Data -------------------- */
  /* ------------- Props ------------------- */
  @Prop({ default: () => [] }) readonly steps: object[];
  @Prop({ default: () => 1 }) stepNumber: number;

  badgeClass(item: any) {
    if (item.isValid) {
      return 'badge-success';
    }

    if (this.stepNumber === item.id) {
      if (item.isValid) {
        return 'badge-success';
      }
      return 'badge-primary';
    }

    return 'badge-secondary';
  }
  /* ------------- Computed ---------------- */
  /* ------------- Methods ----------------- */
  /* ------------- Lifecycle Hooks --------- */
  emitMenuSelection(id: number) {
    this.$emit('change', id);
  }
}
